import React from 'react'
import {Col, Nav,} from "reactstrap";
import Row from "reactstrap/es/Row";
import dateHelpers from "../../helpers/DateHelper";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import lsHelpers from "../../helpers/LsHelper";
import {Redirect} from "react-router-dom";
import businessHelper from "../../helpers/BusinessHelper";
import WeekDayPreview from "./WeekDayPreview";
import {report_strings} from "../../translations/report_translations";
import ClassApiService from "../../api/classes-api-service";
import {MdKeyboardArrowLeft, MdKeyboardArrowRight} from "react-icons/md";
import {isMobile} from "react-device-detect";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let reportStrings = new LocalizedStrings(report_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const deviceBasedHeight = isMobile ? 80 : 120

const propTypes = {};

export default class WeekSchedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reloadCalendar: true,
            isLoading: false,
            weekShift: lsHelpers.getWeekScheduleShift(),
            weekDates: 0,
            weekSchedule: null,
            canRequestSchedule: true,
            curDate: null,
            filters: this.props.filters
        };

        console.log(this.props)

        this.getWeekSchedule = this.getWeekSchedule.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.updateSchedule === true) {
            this.getWeekSchedule()
        }

        if (nextProps.filters !== this.state.filters) {
            this.setState({filters: nextProps.filters});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.weekShift != this.state.weekShift) {
            this.getWeekSchedule()
        }
    }

    componentDidMount() {
        this.getWeekSchedule()
    }

    filterClasses(classes) {
        if (this.state.filters.teachers !== null || this.state.filters.rooms !== null) {

            if (this.state.filters.teachers !== null && this.state.filters.teachers.length > 0) {
                const teacherIds = this.state.filters.teachers.map(t => t.id);
                if (teacherIds && teacherIds.length > 0) {
                    classes = classes.filter(c => teacherIds.includes(c.teacher_id))
                }
            }

            if (this.state.filters.rooms !== null && this.state.filters.rooms.length > 0) {
                const roomIds = this.state.filters.rooms.map(t => t.id);
                if (roomIds && roomIds.length > 0) {
                    classes = classes.filter(c => roomIds.includes(c.room_id))
                }
            }
        }

        return classes
    }

    renderSchedule() {
        return this.state.weekSchedule.map((dayEvents, index) => {
            return (
                <div style={{height: deviceBasedHeight, marginBottom: 10, overflowY: 'auto', overflowX: 'hidden', borderRadius: 20}}
                     key={index}>
                    <WeekDayPreview
                        key={index}
                        date={dayEvents.date_web}
                        events={dayEvents.events.concat(this.filterClasses(dayEvents.classes))}
                        fromCalendar={true}
                        goToClass={this.props.goToClass}
                        openEvent={this.props.openEvent}
                        addClass={this.props.addClass}
                        updateDayPreview={this.state.updateDayPreview}
                        subUser={businessHelper.subUser()}
                        filters={this.state.filters}
                    />
                </div>)
        });
    }

    render() {

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            lsHelpers.logout()
            return <Redirect from="*" to="/auth/login"/>
        }

        this.localize();

        if (this.state.reloadCalendar === true) {
            //this.getCalendar()
        }

        return (
            <>
                {/*<Row>*/}
                {/*    <div className="col mr-3 mb-4 mt--4">*/}
                {/*        <Nav className="justify-content-center" pills>*/}
                {/*            <Button*/}
                {/*                color="secondary"*/}
                {/*                href="#pablo"*/}
                {/*                onClick={e => this.anotherWeekEvents(e, -1)}*/}
                {/*                size="sm"*/}
                {/*            >*/}
                {/*                <span className="d-none d-md-block">⬅️ {commonStrings.navigation.prev_week}</span>*/}
                {/*                <span className="d-md-none">{"<"}</span>*/}
                {/*            </Button>*/}
                {/*            {this.state.weekShift != 0 &&*/}
                {/*            <Button*/}
                {/*                color="success"*/}
                {/*                href="#pablo"*/}
                {/*                onClick={e => this.resetShift(e)}*/}
                {/*                size="sm"*/}
                {/*            >*/}
                {/*                <span className="d-none d-md-block">{reportStrings.this_week}</span>*/}
                {/*                <span className="d-md-none">{"Today"}</span>*/}
                {/*            </Button>*/}
                {/*            }*/}
                {/*            <Button*/}
                {/*                color="secondary"*/}
                {/*                href="#pablo"*/}
                {/*                onClick={e => this.anotherWeekEvents(e, 1)}*/}
                {/*                size="sm"*/}
                {/*            >*/}
                {/*                <span className="d-none d-md-block">{commonStrings.navigation.next_week} ➡️</span>*/}
                {/*                <span className="d-md-none">{">"}</span>*/}
                {/*            </Button>*/}
                {/*        </Nav>*/}
                {/*    </div>*/}
                {/*</Row>*/}
                <div style={{
                    display: "flex",
                    flexFlow: "row",
                    marginLeft: 20,
                    marginRight: 20,
                    justifyContent: "space-around",
                    marginBottom: 20,
                }}>

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "50px",
                            minHeight: 50,
                            boxShadow: "2px 2px 4px rgba(0,0,0,.2)",
                            borderRadius: 25,
                            background: "#323238",
                            cursor: "pointer"
                        }}
                        onClick={e => this.anotherWeekEvents(e, -1)}
                    >
                        <MdKeyboardArrowLeft color="white" size={30}/>️
                    </div>

                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%"
                    }}>
                        <h3 style={{background: "#ecebeb", padding: 10, margin:0, borderRadius: 10, color: "#323238"}}>
                            {this.weekDatesLabel()}
                        </h3>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "50px",
                            minHeight: 50,
                            boxShadow: "2px 2px 4px rgba(0,0,0,.2)",
                            borderRadius: 25,
                            background: "#323238",
                            cursor: "pointer"
                        }}
                        onClick={e => this.anotherWeekEvents(e, 1)}
                    >
                        <MdKeyboardArrowRight color="white" size={30}/>️
                    </div>

                </div>
                <Col xl="12">
                    {this.state.weekSchedule &&
                    <div style={{
                        width: "100%",
                        overflowX: "scroll",
                        flexWrap: "false",
                        display: "flex",
                        flexFlow: "column"
                    }}>
                        {this.renderSchedule()}
                    </div>
                    }
                </Col>
            </>
        )
    }

    editClassAction() {
    }

    openEvent() {
    }

    goToClass() {
        this.props.goToClass()
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    anotherWeekEvents(e, number) {
        e.preventDefault();
        const newValue = this.state.weekShift + number
        lsHelpers.updateWeekScheduleShift(newValue);
        this.setState({weekShift: newValue, canRequestSchedule: true})
    }

    resetShift(e) {
        e.preventDefault();
        lsHelpers.updateWeekScheduleShift(0);
        this.setState({weekShift: 0, canRequestSchedule: true})
    }

    weekDatesLabel() {
        const date = dateHelpers.addDay(new Date(), this.state.weekShift * 7)
        const dates = dateHelpers.weekDates(date);
        if (dates && dates.length > 0) {
            return `${dateHelpers.formatDate(dates[0])} - ${dateHelpers.formatDate(dates[dates.length - 1])}`
        } else {
            return ""
        }
    }

    getWeekSchedule() {
        this.setState({weekSchedule: null, isLoading: true})
        const date = dateHelpers.addDay(new Date(), this.state.weekShift * 7)
        const dates = dateHelpers.weekDates(date);

        if (dates && dates.length > 1) {
            this.setState({isLoading: true})
            ClassApiService.weekEvents(dates[0], dates[dates.length - 1])
                .then(res => {
                    if (res) {
                        this.setState({weekSchedule: res.week_schedule, isLoading: false, canRequestSchedule: false})
                    } else {
                        this.setState({isLoading: false, canRequestSchedule: true})
                    }
                })
                .catch(function (error) {
                    this.setState({isLoading: false, canRequestSchedule: true})
                });
        }
    }
}

WeekSchedule.propTypes = propTypes;